import { render, staticRenderFns } from "./PlansLandingPages.vue?vue&type=template&id=5006de08&scoped=true&lang=pug"
import script from "./PlansLandingPages.vue?vue&type=script&lang=js"
export * from "./PlansLandingPages.vue?vue&type=script&lang=js"
import style0 from "./PlansLandingPages.vue?vue&type=style&index=0&id=5006de08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006de08",
  null
  
)

export default component.exports